import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b79f80f")

_pushScopeId("data-v-2b79f80f")
const _hoisted_1 = { class: "reservation_calendar" }
const _hoisted_2 = { class: "px-2" }
const _hoisted_3 = { class: "week_days" }
const _hoisted_4 = { class: "calendar_days" }
const _hoisted_5 = {
  key: 0,
  class: "reservations_div"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.week, (day, i) => {
          return (_openBlock(), _createBlock("span", {
            class: ["uppercase", _ctx.returnWeekClass(day)],
            key: i
          }, _toDisplayString(day.value), 3))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monthDays, (day, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "calendar_day"
          }, [
            _createVNode("div", {
              class: ["day", _ctx.returnDayClass(day)],
              onClick: ($event: any) => (_ctx.dayClicked(day))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$filters.date(day, "DD")) + " ", 1),
              (_ctx.returnReservations(day) > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.returnReservations(day)), 1))
                : _createCommentVNode("", true)
            ], 10, ["onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
})